import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.16675 5.16602V0.166016H6.83342V5.16602H11.8334V6.83268H6.83342V11.8327H5.16675V6.83268H0.166748V5.16602H5.16675Z",
		fill: "currentColor"
	})
});
export default SvgAdd;
